import React, { FC } from 'react';

import { JFieldBaseProps, JTextHTMLTypes } from './../../models';
import { JText } from './JText';




export const JMail: FC<JFieldBaseProps> = props => <JText {...props} htmlType={JTextHTMLTypes.EMAIL} />